import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const getDefaultFilters = () => ({
  selectedGenre: 'all',
  sortBy: 'trending',
  imdbRating: 0,
  rottenTomatoesRating: 0,
  fromYear: '',
  toYear: '',
  availableLT: 'false'
});

export const useFiltersStore = create(
  persist(
    (set, get) => ({
      // Shared filters between movie and TV pages
      sharedFilters: getDefaultFilters(),
      
      // Set filters (merges with existing)
      setFilters: (newFilters) => set((state) => ({
        sharedFilters: { ...state.sharedFilters, ...newFilters }
      })),
      
      // Reset filters to defaults
      resetFilters: () => set({ sharedFilters: getDefaultFilters() }),
      
      // Check if any filters are active
      hasActiveFilters: () => {
        const filters = get().sharedFilters;
        return (
          filters.imdbRating > 0 ||
          filters.rottenTomatoesRating > 0 ||
          filters.fromYear !== '' ||
          filters.toYear !== '' ||
          filters.selectedGenre !== 'all' ||
          filters.sortBy !== 'trending' ||
          filters.availableLT === 'true'
        );
      }
    }),
    {
      name: 'filmudb-filters', // localStorage key
      version: 1,
    }
  )
);
